export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
export const SMS_MFA = 'SMS_MFA';
export const NO_MFA = 'NOMFA';
